import React from "react";
import { Route, Switch } from "react-router-dom";
import { CataloguePath } from "routes/createContent/paths";
import LessonsList from "./views/LessonsList";
import LessonEditorPage from "./views/LessonEditorPage";
import { CatalogueChangesPage } from "routes/createContent/components/CatalogueChangesPage";

const Lessons: React.VFC = () => (
  <Switch>
    <Route path={CataloguePath.Lessons_Changes}>
      <CatalogueChangesPage kind="lesson" backTo={CataloguePath.Lessons} />
    </Route>
    <Route exact path={CataloguePath.Lessons_New}>
      <LessonEditorPage />
    </Route>
    <Route path={CataloguePath.Lessons_Edit}>
      <LessonEditorPage />
    </Route>
    <Route path={CataloguePath.Lessons}>
      <LessonsList />
    </Route>
  </Switch>
);

export default Lessons;
